var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketInsights(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 112,
    viewBox: "0 0 177 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1322_451",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 177,
    height: 112
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 112,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1322_451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9453 71.4727H99.3347V94.9997H77.9453V71.4727Z",
    className: "primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.862 52.2227H54.4167C53.2358 52.2227 52.2783 53.1802 52.2783 54.3611V92.8609C52.2783 93.4281 52.5032 93.9723 52.9042 94.3734C53.306 94.7744 53.8495 95 54.4167 95H73.6666V69.3335C73.6666 68.1525 74.6248 67.1943 75.8058 67.1943H101.472C102.039 67.1943 102.584 67.4199 102.985 67.821C103.386 68.222 103.611 68.7663 103.611 69.3335V95H122.861C123.429 95 123.972 94.7744 124.374 94.3734C124.775 93.9723 125 93.4281 125 92.8609V54.3611C125 53.7939 124.775 53.2503 124.374 52.8486C123.972 52.4475 123.429 52.2227 122.861 52.2227L122.862 52.2227Z",
    className: "secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.841 30.8333L102.285 18H95.0557L98.8627 30.8333H110.841Z",
    className: "primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7793 18H86.501L82.8223 30.8333H94.4582L90.7793 18Z",
    className: "primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4147 30.8333L82.2218 18H74.9923L66.4365 30.8333H78.4147Z",
    className: "primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2505 35.1104H75.8062C76.9871 35.1104 77.9453 36.2913 77.9453 37.2495V45.8052C77.9453 46.9862 76.9878 47.9444 75.8062 47.9444H67.2505C66.0695 47.9444 65.1113 46.7634 65.1113 45.8052V37.2495C65.1113 36.0686 66.0688 35.1104 67.2505 35.1104V35.1104Z",
    className: "primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2013 18H62.9718C62.2986 18 61.6648 18.3173 61.2609 18.8558L49.0693 30.8333H61.6463L70.2013 18Z",
    className: "primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8333 35.1104H50.1391C48.9582 35.1104 48 36.0686 48 37.2495V45.8052C48 46.3724 48.2256 46.916 48.6266 47.3177C49.0277 47.7188 49.5719 47.9436 50.1391 47.9436H60.8333V35.1104Z",
    className: "primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3618 35.1104H92.9175C94.0985 35.1104 95.0567 36.2913 95.0567 37.2495V45.8052C95.0567 46.9862 94.0992 47.9444 92.9175 47.9444H84.3618C83.1809 47.9444 82.2227 46.7634 82.2227 45.8052V37.2495C82.2227 36.0686 83.1801 35.1104 84.3618 35.1104Z",
    className: "primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.472 35.1104H110.028C111.209 35.1104 112.167 36.2913 112.167 37.2495V45.8052C112.167 46.9862 111.21 47.9444 110.028 47.9444H101.472C100.291 47.9444 99.333 46.7634 99.333 45.8052V37.2495C99.333 36.0686 100.29 35.1104 101.472 35.1104Z",
    className: "primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.077 18H114.307C114.98 18 115.614 18.3173 116.018 18.8558L128.209 30.8333H115.633L107.077 18Z",
    className: "primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.445 35.1104H127.139C127.707 35.1104 128.251 35.3359 128.652 35.737C129.053 36.138 129.279 36.6823 129.279 37.2495V45.8052C129.279 46.3724 129.053 46.916 128.652 47.3177C128.251 47.7188 127.707 47.9436 127.139 47.9436H116.445V35.1104Z",
    className: "primary-color"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketInsights);
export default __webpack_public_path__ + "static/media/market-insights.6dc56eb7b503987591e0a1ef2e530ba4.svg";
export { ForwardRef as ReactComponent };